import { FormStatus } from "@/modules/FormTemplate/models/FormStatus";
import { FORM_CONSTANTS } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CARD_ADD_CONSTANTS } from "./constants/CardAddConstant";

@Component({
  name: "CardAddForm"
})
export default class CardAddForm extends Vue {
  @Prop() formTemp!: FormStatus;
  @Prop() formSelect?: { key: string; name: string }[];

  @Prop() index!: number;
  @Prop({ default: () => true }) enableDuplicate!: boolean;

  cardClass = STYLE_CLASSES.CARD;
  switchClass = STYLE_CLASSES.SWITCH;
  VIEW_BUTTON = FORM_CONSTANTS.BUTTON.VIEW;
  ADD_BUTTON = FORM_CONSTANTS.BUTTON.ADD;
  ADDED_BUTTON = FORM_CONSTANTS.BUTTON.ADDED;
  roundBtnClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  itemsByStepLabel = FORM_CONSTANTS.LABEL.COPY_FORM;

  get checkForm() {
    if (this.formSelect === undefined) return false;
    const findFormCheck = this.formSelect.find(
      (form: { key: string; name: string }) => {
        if (
          form.key === this.formTemp._key ||
          form.name === this.formTemp.name
        ) {
          return true;
        }
      }
    );
    const check = findFormCheck ? true : false;
    return check;
  }

  viewFormTemp(e: string) {
    this.$emit(CARD_ADD_CONSTANTS.EMIT.VIEW_FORM_TEMP, e);
  }

  addForm(e: number) {
    this.$emit(CARD_ADD_CONSTANTS.EMIT.ADD_FORM, e);
  }
}
